import { FC, useEffect } from 'react';
import { Modal } from '@mui/material';
import styled, { css } from 'styled-components';
import { MediaType } from './MediaCard';

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const mediaCss = css`
  max-height: 90%;
  max-width: 80%;
`;

const StyledVideo = styled.video`
  ${mediaCss}
`;
const StyledImage = styled.img`
  ${mediaCss}
`;

type Props = {
  mediaType: MediaType;
  mediaUrl: string;
  isOpen: boolean;
  onClose: () => void;
};

export const FullscreenMediaFrame: FC<Props> = ({
  mediaType,
  mediaUrl,
  isOpen,
  onClose,
}) => {
  useEffect(() => {
    if (!isOpen) {
      return;
    }
    const exitFullScreenOnESC = (event: { code: string }) => {
      if (event.code === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', exitFullScreenOnESC);
    return () => {
      window.removeEventListener('keydown', exitFullScreenOnESC);
    };
  }, [isOpen, onClose]);

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Wrapper>
        {mediaType === 'video' && (
          <StyledVideo autoPlay controls>
            <source src={mediaUrl} type="video/mp4" />
          </StyledVideo>
        )}
        {mediaType === 'image' && <StyledImage src={mediaUrl} />}
      </Wrapper>
    </Modal>
  );
};
